import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../../Components/Assests/CSS/portalLanding.css";

export default function PortalLanding() {

    const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState("home");

    useEffect(() => {

        const sections = document.querySelectorAll("section[id]");

        const handleScroll = () => {
            let current = "";
        
            sections.forEach((section) => {
                const sectionTop = section.offsetTop - 150;
                const sectionHeight = section.offsetHeight;
        
                if (
                    window.scrollY >= sectionTop &&
                    window.scrollY < sectionTop + sectionHeight
                ) {
                    current = section.getAttribute("id");
                }
            });
        
            setActiveSection(current);
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);

    }, []);

    const scrollToSection = (id) => {
        document.getElementById(id)?.scrollIntoView({
            behavior: "smooth"
        });
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg fixed-top landing-navbar">
                <div className="container">

                    <a className="navbar-brand" href="/">
                        <h1>NSphere</h1>
                    </a>

                    <button
                        className="navbar-toggler"
                        data-bs-toggle="collapse"
                        data-bs-target="#menu"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="menu">
                        <ul className="navbar-nav ms-auto">

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeSection === "home" ? "active" : ""}`}
                                    onClick={() => scrollToSection("home")}
                                >
                                    Home
                                </button>
                            </li>

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeSection === "features" ? "active" : ""}`}
                                    onClick={() => scrollToSection("features")}
                                >
                                    Features
                                </button>
                            </li>

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeSection === "contact" ? "active" : ""}`}
                                    onClick={() => scrollToSection("contact")}
                                >
                                    Contact
                                </button>
                            </li>

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeSection === "portal" ? "active" : ""}`}
                                    onClick={() => scrollToSection("portal")}
                                >
                                    Portal Login
                                </button>
                            </li>
                            <li className="nav-item">
                                <Link to="/privacy-policy">
                                    <button className={`nav-link ${activeSection === "privacy" ? "active" : ""}`}>
                                        Privacy Policy
                                    </button>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link to="/terms-of-service">
                                    <button className={`nav-link ${activeSection === "terms" ? "active" : ""}`}>
                                        Terms
                                    </button>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <section id="home" className="hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <h1>Nsphere Healthcare</h1>
                            <h2>
                                A Patient Management System developed by
                                <br />
                                COOPERWIND INDIA PRIVATE LIMITED
                            </h2>
                            <p>
                                Secure cloud-based healthcare management platform for hospitals,
                                clinics and healthcare providers.
                            </p>
                            <div className="mt-4">
                                <button
                                    className="btn btn-light btn-custom me-3"
                                    onClick={() => scrollToSection("portal")}
                                >
                                    Login
                                </button>

                                <button
                                    className="btn btn-outline-light btn-custom"
                                    onClick={() => scrollToSection("contact")}
                                >
                                    Contact Us
                                </button>
                            </div>
                        </div>

                        <div className="col-lg-5">
                            <div className="glass-card">
                                <h4>Healthcare Platform</h4>
                                <p>✓ Appointment Management</p>
                                <p>✓ Patient Records</p>
                                <p>✓ Lab Reports</p>
                                <p>✓ Prescription Tracking</p>
                                <p>✓ WhatsApp Notifications</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-md-3">
                            <div className="feature-card text-center">
                                <i className="fas fa-building feature-icon"></i>
                                <h5>Developed By</h5>
                                <p>COOPERWIND INDIA PRIVATE LIMITED</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="feature-card text-center">
                                <i className="fas fa-heartbeat feature-icon"></i>
                                <h5>Product</h5>
                                <p>Nsphere Healthcare</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="feature-card text-center">
                                <i className="fas fa-laptop-medical feature-icon"></i>
                                <h5>Category</h5>
                                <p>Patient Management System</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="feature-card text-center">
                                <i className="fab fa-whatsapp feature-icon"></i>
                                <h5>Communication</h5>
                                <p>WhatsApp Notifications</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section" id="features">
                <div className="container">

                    <h2 className="section-title">Platform Features</h2>

                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="fas fa-calendar-check"></i>
                                </div>
                                <h4 className="mt-3">Appointment Management</h4>
                                <p>Manage appointments, scheduling and patient visits efficiently.</p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="fas fa-user-injured"></i>
                                </div>
                                <h4 className="mt-3">Patient Records</h4>
                                <p>Secure digital storage and access of patient information.</p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="fas fa-file-medical"></i>
                                </div>
                                <h4 className="mt-3">Lab Reports</h4>
                                <p>Centralized management of laboratory reports and results.</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="fas fa-capsules"></i>
                                </div>
                                <h4 className="mt-3">Prescription Tracking</h4>
                                <p>Track patient prescriptions and treatment history digitally.</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="fab fa-whatsapp"></i>
                                </div>
                                <h4 className="mt-3">WhatsApp Notifications</h4>
                                <p>Automated reminders and notifications through WhatsApp.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section bg-light" id="whatsapp">
                <div className="container">
                    <h2 className="section-title">WhatsApp Notifications</h2>
                    <div className="policy-box text-center">
                        <i
                            className="fab fa-whatsapp"
                            style={{
                                fontSize: "70px",
                                color: "#25D366"
                            }}
                        />
                        <p className="mt-4">
                            Nsphere Healthcare may send appointment confirmations,
                            reminders, rescheduling notifications and service-related
                            communications through WhatsApp and other communication channels.
                        </p>
                    </div>
                </div>
            </section>

            <section className="section bg-light" id="portal">
                <div className="container">

                    <h2 className="section-title">Portal Access</h2>

                    <div className="login-card text-center">
                        <h3>Healthcare Portal Login</h3>
                        <p className="mt-3">Secure access for Administrators, Doctors, Receptionists and Patients.</p>

                        <div className="row g-4 mt-2">
                            <div className="col-md-3">
                                <div className="portal-user-card">
                                    <i className="fas fa-user-shield"></i>
                                    <h5>Admin</h5>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="portal-user-card">
                                    <i className="fas fa-user-doctor"></i>
                                    <h5>Doctor</h5>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="portal-user-card">
                                    <i className="fas fa-user-nurse"></i>
                                    <h5>Reception</h5>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="portal-user-card">
                                    <i className="fas fa-hospital-user"></i>
                                    <h5>Patient</h5>
                                </div>
                            </div>
                        </div>

                        <Link to="/staff-login" className="btn btn-light btn-lg portal-btn mt-4">
                            <i className="fas fa-right-to-bracket me-2"></i>
                            Access Portal
                        </Link>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <h2 className="section-title">About Nsphere Healthcare</h2>
                    <div className="policy-box">
                        <p>
                            Nsphere Healthcare is a cloud-based Patient Management System
                            developed by COOPERWIND INDIA PRIVATE LIMITED.
                        </p>
                        <p>
                            The platform helps healthcare providers manage appointments,
                            patient records, doctor schedules, notifications and operational
                            workflows through a secure and scalable solution.
                        </p>
                    </div>
                </div>
            </section>

            <section className="section bg-light" id="contact">
                <div className="container">
                    <h2 className="section-title">Contact Us</h2>
                    <div className="contact-card">
                        <div className="row g-4">
                            <div className="col-md-3">
                                <div className="d-flex align-items-center">
                                    <div className="contact-icon me-3"><i className="fas fa-envelope"></i></div>
                                    <div>
                                        <h5 className="mb-1">Email</h5>
                                        <p className="mb-0">TL-Support@Cooperwind.in</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex align-items-center">
                                    <div className="contact-icon me-3"><i className="fas fa-phone-alt"></i></div>
                                    <div>
                                        <h5 className="mb-1">Phone</h5>
                                        <p className="mb-0">+91 95244 21927</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex align-items-center">
                                    <div className="contact-icon me-3">
                                        <i className="fas fa-globe-americas"></i>
                                    </div>
                                    <div>
                                        <h5 className="mb-1">Website</h5>
                                        <p className="mb-0">
                                            <a href="https://healthcare.nsphere.in" target="_blank">
                                                healthcare.nsphere.in
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex align-items-center">
                                    <div className="contact-icon me-3"><i className="fas fa-location-dot"></i></div>
                                    <div>
                                        <h5 className="mb-1">Location</h5>
                                        <p className="mb-0">Chennai - Oragadam - 603204, India</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer className="footer">
                <div className="container">
                    <div className="text-center mb-3">
                        <h4 className="text-white">Nsphere Healthcare</h4>
                        <p>
                            Developed and Maintained by
                            <strong> COOPERWIND INDIA PRIVATE LIMITED</strong>
                        </p>
                    </div>

                    <div className="text-center footer-links">
                        <Link to="/privacy-policy" className="footer-link-pill">Privacy Policy</Link>
                        <Link to="/terms-of-service" className="footer-link-pill">Terms of Service</Link>
                        <a href="#contact" className="footer-link-pill">Contact Us</a>
                        <Link to="/staff-login" className="footer-link-pill">Login</Link>
                    </div>

                    <hr />

                    <div className="text-center">
                        © 2026 COOPERWIND INDIA PRIVATE LIMITED
                        <br />
                        All Rights Reserved.
                    </div>
                </div>
            </footer>

        </>
    );
}